module.exports = __webpack_public_path__ + "static/other/lab_diagnosis_diagnosis_scene.8d2189a3.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/labDiagnosisGame/lab_diagnosis_diagnosis_scene.json
// module id = 2239
// module chunks = 0